import * as React from 'react';
import { observer } from 'mobx-react';

import { SvgIcon } from '../../WebGiving/components/svg-icon';
import logo from '../../WebGiving/assets/svg/pushpay-logo.svg';
import { PayerOnboardingPushpayInfo, PayerOnboardingMerchantInfo } from '../payer-onboarding-generated';
import { PayerOnboardingUserAction } from '../payer-onboarding-user-actions';
import { ModalType } from '../modals/modal-type';
import { classNames } from '../../Shared/utils/classnames';

import {
	footer,
	footerContainer,
	footerLink,
	orgInfo,
	separator,
	pushpayInfoWrapper,
	pushpayLogoWrapper,
	pushpayLogo,
	info,
	component,
	horizontalSeparator,
} from  '../../WebGiving/main/webgiving-main.less';

export interface IFooterProp {
	merchant: PayerOnboardingMerchantInfo;
	pushpayInfo: PayerOnboardingPushpayInfo;
	raiseAction: (action: PayerOnboardingUserAction) => void;
}

@observer
export class PayerOnboardingMainFooter extends React.Component<IFooterProp> {
	render() {
		const { merchant, pushpayInfo, raiseAction } = this.props;
		const {
			HelpCenterLink: helpCenterLink,
		} = pushpayInfo;
		const {
			LegalName: legalName,
			Address: address,
			TradingName: tradingName,
			WebsiteUrl: websiteUrl,
		} = merchant;

		const merchantInfoAvailable: boolean = !!merchant.Handle;

		return (
			// tslint:disable:max-line-length
			<FooterContainer>
				<p>
					By creating an account you are agreeing to the Pushpay <FooterModalLink data-pp-at-target="Pushpay Terms" modalType={ModalType.PushpayTerms} raiseAction={raiseAction}>Terms &amp; Conditions</FooterModalLink>.
					Pushpay takes the security of your data seriously, read more about our <FooterModalLink data-pp-at-target="Pushpay Privacy" modalType={ModalType.PushpayPrivacy} raiseAction={raiseAction}>Privacy Policy</FooterModalLink>.
					{merchantInfoAvailable &&
						<span> In addition, you are also agreeing to the specific <FooterModalLink data-pp-at-target="Merchant Terms" modalType={ModalType.MerchantTerms} raiseAction={raiseAction}>Terms &amp; Conditions</FooterModalLink> and <FooterModalLink data-pp-at-target="MerchantPrivacy" modalType={ModalType.MerchantPrivacy} raiseAction={raiseAction}>Privacy Policy</FooterModalLink> provided by {websiteUrl ? <a className={footerLink} href={websiteUrl} target="_blank" rel="noopener noreferrer">{tradingName}</a> : tradingName}.</span>
					}
				</p>
				{merchantInfoAvailable &&
					<div className={orgInfo}>
						{legalName ? <p><strong>Organization Legal Name</strong>: {legalName}</p> : undefined}
						{legalName && address ? <span className={separator}>|</span> : undefined}
						{address ? <p><strong>Address</strong>: {address}</p> : undefined}
					</div>
				}
				<FooterSeparator />
				<FooterPushpaySection helpCenterLink={helpCenterLink} />
			</FooterContainer>
			// tslint:enable:max-line-length
		);
	}

	openPushpayTerms = () => {
		this.props.raiseAction(new PayerOnboardingUserAction.OpenModalDialog(ModalType.PushpayTerms));
	}
}

interface IFooterModalLinkProps {
	modalType: ModalType;
	raiseAction: (action: PayerOnboardingUserAction) => void;
}

@observer
class FooterModalLink extends React.Component<IFooterModalLinkProps> {
	render() {
		return <a href="#" className={footerLink} onClick={this.handleClick}>{this.props.children}</a>;
	}

	private handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		event.preventDefault();

		const { modalType } = this.props;
		this.props.raiseAction(new PayerOnboardingUserAction.OpenModalDialog(modalType));
	}
}

@observer
export class FooterContainer extends React.Component<{}, {}> {
	render() {
		const {children} = this.props;
		return(
			<footer className={footer}>
				<div className={classNames(footerContainer, 'container')}>
					{children}
				</div>
			</footer>
		);
	}
}

export const FooterSeparator = () => <hr className={horizontalSeparator} />;

export const FooterPushpaySection = observer(({ helpCenterLink }: { helpCenterLink: string }) => {
	return(
		<div className={pushpayInfoWrapper}>
			<div className={pushpayLogoWrapper}>
				<SvgIcon className={classNames(pushpayLogo, component)} svg={logo} />
			</div>
			<div className={info}>
				<a className={classNames(footerLink, component)} href={helpCenterLink} target="_blank" rel="noopener noreferrer">Help Center</a>
				<span className={separator}>|</span>
				<div className={component}>&copy;{new Date().getFullYear()} Pushpay<sup>&reg;</sup> Ltd, All rights reserved</div>
			</div>
		</div>
	);
});
